var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.25C4.62391 0.25 0.25 4.62391 0.25 10C0.25 15.3761 4.62391 19.75 10 19.75C15.3761 19.75 19.75 15.3761 19.75 10C19.75 4.62391 15.3761 0.25 10 0.25ZM15.0742 6.73234L8.77422 14.2323C8.70511 14.3147 8.61912 14.3812 8.52207 14.4273C8.42502 14.4735 8.31918 14.4983 8.21172 14.5H8.19906C8.09394 14.5 7.99 14.4778 7.89398 14.435C7.79797 14.3922 7.71202 14.3297 7.64172 14.2516L4.94172 11.2516C4.87315 11.1788 4.81981 11.0931 4.78483 10.9995C4.74986 10.9059 4.73395 10.8062 4.73805 10.7063C4.74215 10.6064 4.76617 10.5084 4.8087 10.4179C4.85124 10.3275 4.91142 10.2464 4.98572 10.1796C5.06002 10.1127 5.14694 10.0614 5.24136 10.0286C5.33579 9.99578 5.43581 9.98219 5.53556 9.98861C5.63531 9.99502 5.73277 10.0213 5.82222 10.0659C5.91166 10.1106 5.99128 10.1726 6.05641 10.2484L8.17938 12.6072L13.9258 5.76766C14.0547 5.61863 14.237 5.52631 14.4335 5.51066C14.6299 5.49501 14.8246 5.55728 14.9754 5.68402C15.1263 5.81075 15.2212 5.99176 15.2397 6.18793C15.2582 6.3841 15.1988 6.57966 15.0742 6.73234Z",
    fill: "#228220"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.858cf99fee38d1d4756026978b26acd9.svg";
export { ForwardRef as ReactComponent };